import React from "react";

const NSESection = ({ formData, setFormData }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <section className="form-section">
      <h3>4-1. NSE</h3>

      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">Initial ROSC 후의 NSE :</label>
          <div className="input">
            <input
              type="text"
              id="NSE_Inital_ROSC"
              name="NSE_Inital_ROSC"
              value={formData.NSE_Inital_ROSC || ""}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>

      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">24시간 후의 NSE :</label>
          <div className="input">
            <input
              type="text"
              id="NSE_24h"
              name="NSE_24h"
              value={formData.NSE_24h || ""}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>

      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">36시간 후의 NSE :</label>
          <div className="input">
            <input
              type="text"
              id="NSE_36h"
              name="NSE_36h"
              value={formData.NSE_36h || ""}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>

      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">48시간 후의 NSE :</label>
          <div className="input">
            <input
              type="text"
              id="NSE_48h"
              name="NSE_48h"
              value={formData.NSE_48h || ""}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>

      <div className="input-wrapper-1column">
        <div className="block-1column">
          <label className="item_title_1col">72시간 후의 NSE :</label>
          <div className="input">
            <input
              type="text"
              id="NSE_72h"
              name="NSE_72h"
              value={formData.NSE_72h || ""}
              onChange={handleInputChange}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NSESection;
